var Promise = require('bluebird');


module.exports = {
  config: {
    target: {
      className: 'tour-highlight'
    }
  },
  steps: [{
    target: {
      el: '#tour1',
      triggerNextOn: 'click',
    },
    toast: {
      body: 'Hello Step 1',
    },
  }, {
    target: {
      el: '#tour2',
      triggerNextOn: 'click',
    },
    toast: {
      body: 'Hello Step 2',
      link: 'http://google.com/search?q=wtf',
    },
  },{
    target: {
      el: '#tour3',
      triggerNextOn: 'click',
    },
    toast: {
      body: 'Hello Step 3',
    },
    before: function(){
      return Promise.all([this.Wait.Trigger('foo'), this.Wait.State('public.tour-two')]);
    }
  },{
    target: {
      el: '#tour4',
      triggerNextOn: 'blur',
    },
    toast: {
      body: 'Hello Step 4',
    },
    after: function(){
      return new Promise(function(resolve, reject){
        $('#tour4').val() ? resolve() : reject();
      })
    }
  },{
    target: {
      el: '#tour5',
      triggerNextOn: 'click',
    },
    toast: {
      body: 'Hello Step 5',
    }
  }]
}
